<div class="sidenav-container">
  @if (!isEmbedded) {
    <div class="sidenav-nav" [ngClass]="isCollapsed() ? 'nav-collapsed' : ''">
      <div class="nav-items">
        @for (navItem of navItems; track navItem.id) {
          <div>
            <a
              class="nav-item"
              [routerLink]="navItem.link"
              [routerLinkActiveOptions]="{
                exact: navItem.link === '' ? true : false,
              }"
              [routerLinkActive]="['is-active']"
              #rla="routerLinkActive"
              [ngClass]="{
                'active-link': navItem.children ? rla.isActive && isCollapsed() : rla.isActive,
              }"
              (click)="clickOnNavItem(navItem)"
            >
              <span class="entry">
                <span class="material-symbols-outlined"> {{ navItem.icon }} </span>
                @if (!isCollapsed()) {
                  <span class="label">{{ navItem.label }}</span>

                  @if (navItem.children) {
                    <span class="material-symbols-outlined child-expand"
                      >{{ itemExpanded() === navItem.id ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                    </span>
                  }
                }
              </span>
            </a>

            @if (itemExpanded() === navItem.id && !isCollapsed()) {
              @for (navChild of navItem.children; track navChild.id) {
                <a
                  class="nav-item nav-child"
                  [routerLink]="navChild.link"
                  [routerLinkActiveOptions]="{
                    exact: navChild.link === '' ? true : false,
                  }"
                  routerLinkActive="active-link"
                  (click)="clickOnNavItem(navChild)"
                >
                  <span class="entry">
                    <span class="material-symbols-outlined"> {{ navChild.icon }} </span>
                    <span class="label">{{ navChild.label }}</span>
                  </span>
                </a>
              }
            }
          </div>
        }

        <app-divider color="second"></app-divider>
        @if (!isCollapsed()) {
          <div class="external-links-label mat-label-small">External links</div>
        }

        @for (exNavItem of externalNavItems; track exNavItem.label) {
          @if (exNavItem.children && (exNavItem.isVisible ?? true)) {
            <div
              class="nav-item external-link"
              tabindex="0"
              role="button"
              (click)="clickOnExternalNavItem(exNavItem)"
              (keydown.enter)="clickOnExternalNavItem(exNavItem)"
            >
              <span class="entry">
                <span class="material-symbols-outlined"> {{ exNavItem.icon }} </span>
                @if (!isCollapsed()) {
                  <span class="label">{{ exNavItem.label }}</span>
                  <span class="material-symbols-outlined child-expand"
                    >{{ externalItemExpanded() === exNavItem.label ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                  </span>
                }
              </span>
            </div>

            @if (externalItemExpanded() === exNavItem.label && !isCollapsed()) {
              @for (child of exNavItem.children; track child.label) {
                <a class="nav-item external-link nav-child" [href]="child.link" target="_blank" rel="noopener noreferrer">
                  <span class="entry">
                    <span class="material-symbols-outlined"> {{ child.icon }} </span>

                    <span class="label">{{ child.label }}</span>
                  </span>
                </a>
              }
            }
          } @else if (exNavItem.isVisible ?? true) {
            <a class="nav-item external-link" [href]="exNavItem.link" target="_blank" rel="noopener noreferrer">
              <span class="entry">
                <span class="material-symbols-outlined"> {{ exNavItem.icon }} </span>
                @if (!isCollapsed()) {
                  <span class="label">{{ exNavItem.label }}</span>
                }
              </span>
            </a>
          }
        }

        @if (isRiskManager()) {
          <app-divider color="second"></app-divider>
          @if (!isCollapsed()) {
            <div class="admin-label mat-label-small">Admin</div>
          }

          @for (navItem of adminNavItems; track navItem.id) {
            <div>
              <a
                class="nav-item"
                [routerLink]="navItem.link"
                [routerLinkActiveOptions]="{
                  exact: navItem.link === '' ? true : false,
                }"
                [routerLinkActive]="['is-active']"
                #rlaAdmin="routerLinkActive"
                [ngClass]="{
                  'active-link': navItem.children ? rlaAdmin.isActive && isCollapsed() : rlaAdmin.isActive,
                }"
                (click)="clickOnAdminNavItem(navItem)"
              >
                <span class="entry">
                  <span class="material-symbols-outlined"> {{ navItem.icon }} </span>
                  @if (!isCollapsed()) {
                    <span class="label">{{ navItem.label }}</span>

                    @if (navItem.children) {
                      <span class="material-symbols-outlined child-expand"
                        >{{ adminItemExpanded() === navItem.id ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                      </span>
                    }
                  }
                </span>
              </a>

              @if (adminItemExpanded() === navItem.id && !isCollapsed()) {
                @for (navChild of navItem.children; track navChild.id) {
                  <a
                    class="nav-item nav-child"
                    [routerLink]="navChild.link"
                    [routerLinkActiveOptions]="{
                      exact: navChild.link === '' ? true : false,
                    }"
                    routerLinkActive="active-link"
                    (click)="clickOnAdminNavItem(navChild)"
                  >
                    <span class="entry">
                      <span class="material-symbols-outlined"> {{ navChild.icon }} </span>
                      <span class="label">{{ navChild.label }}</span>
                    </span>
                  </a>
                }
              }
            </div>
          }
        }
      </div>
      <app-divider color="second"></app-divider>
      <div class="nav-toggle">
        <button mat-icon-button (click)="updateCollapsed()">
          <span class="material-symbols-outlined">
            {{ isCollapsed() ? 'navigate_next' : 'navigate_before' }}
          </span>
        </button>
      </div>
    </div>
  }
  <div class="router-content">
    <router-outlet />
  </div>
</div>
